import { action, computed, observable } from 'mobx';
import { adminPartnerApi } from '@link/admin/services';
import {
  AccountbaseSupplier,
  SupplierBrief,
  ListSuppliersRequest
} from '@link/admin/services/types';
import { SuppliersStatus } from '@link/share/services/const';

export class Supplier {
  @observable accessor supplier: AccountbaseSupplier | null = null;
  @observable accessor suppliers: SupplierBrief[] = [];
  @observable accessor suppliersLoaded = false;
  @observable accessor loading: boolean = false;

  @action
  async getDetail(supplierId: string) {
    this.loading = true;
    const response = await adminPartnerApi.getSupplierDetail({
      supplierId
    });
    if (response.supplier) {
      this.setSupplier(response.supplier);
    }
    this.setLoading(false);
  }

  @action
  setSupplier(supplier: AccountbaseSupplier) {
    this.supplier = supplier;
  }
  @action
  setSuppliers(suppliers: SupplierBrief[]) {
    this.suppliers = suppliers;
  }
  @action
  setLoading(loading: boolean) {
    this.loading = loading;
  }
  @action
  setSuppliersLoaded(loaded: boolean) {
    this.suppliersLoaded = loaded;
  }
  @action
  async getSuppliers(params?: ListSuppliersRequest) {
    const response = await adminPartnerApi.listSuppliers({
      status: [SuppliersStatus.On],
      ...params
    });
    this.setSuppliers(response.suppliers || []);
    this.setSuppliersLoaded(true);
    return response;
  }

  @action
  async addOrUpdateSupplier(supplier: AccountbaseSupplier) {
    const response = await adminPartnerApi.addOrUpdateSupplier({
      body: { supplier }
    });
    if (response.supplierId) {
      this.setSupplier({ ...this.supplier, ...supplier });
      this.getSuppliers();
    }
    return response;
  }
  @action
  clear() {
    this.supplier = null;
  }

  @computed
  get originalName() {
    return this.supplier?.originalName;
  }

  @action
  getOriginalNameBySupplierId(supplierId: string) {
    return (
      this.suppliers.find(supplier => supplier.supplierId === supplierId)
        ?.originalName || ''
    );
  }
  @computed
  get supplierOpts() {
    return this.suppliers.map(supplier => ({
      label: `${supplier.supplierCustomId}(${supplier.originalName})`,
      value: supplier.supplierId as string
    }));
  }
}

export default new Supplier();
